import { render } from "./AddClinics.vue?vue&type=template&id=5d505005&scoped=true"
import script from "./AddClinics.vue?vue&type=script&lang=js"
export * from "./AddClinics.vue?vue&type=script&lang=js"

import "./AddClinics.vue?vue&type=style&index=0&id=5d505005&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d505005"]])

export default __exports__